import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {WarrantyListComponent} from './components/warranty-list/warranty-list.component';
import {WarrantyComponent} from './components/warranty/warranty-steps/warranty.component';
import {AuthGuardService} from './auth/authguard.service';
import {HeaderComponent} from './components/commons/header/header.component';
import {FooterComponent} from './components/commons/footer/footer.component';
import {LoadingComponent} from './components/commons/loading/loading.component';
import {LoadingScreenInterceptor} from './auth/loading.interceptor';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {I18nPipe} from './services/i18n.pipe';
import {SanitizePipe} from './services/sanitizer.pipe';
import {I18nProvider, i18nProviderFactory} from './services/i18n.service';
import {CustomerDetailsComponent} from './components/warranty/customer-details/customer-details.component';
import {WarrantySummaryComponent} from './components/warranty/warranty-summary/warranty-summary.component';
import {BlacklistComponent} from './components/admin/blacklist/blacklist.component';
import {DealerListComponent} from './components/admin/dealer-list/dealer-list.component';
import {HelpConfigComponent} from './components/admin/help-config/help-config.component';
import {DisclaimerConfigComponent} from './components/admin/disclaimer-config/disclaimer-config.component';
import {WarrantyConfigComponent} from './components/admin/warranty-config/warranty-config.component';
import {AcceptModalComponent} from './components/warranty/accept-modal/accept-modal.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AdminMenuComponent} from './components/admin/admin-menu/admin-menu.component';
import {LoginComponent} from './components/commons/login/login.component';
import {LogoutComponent} from './components/commons/logout/logout.component';
import {AdminPromotionsComponent} from './components/admin/promotion-config/promotions/admin-promotions.component';
import {PromotionsComponent} from './components/promotions/promotions.component';
import {PromotionComponent} from './components/admin/promotion-config/promotion/promotion.component';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import {AccordionModule} from 'ngx-bootstrap/accordion';
import {HelpComponent} from './components/commons/help/help.component';
import {FileUploadModule} from 'ng2-file-upload';
import {EamComponent} from './components/commons/eam/eam.component';
import {CalcLogComponent} from './components/admin/calc-log/calc-log.component';
import {AdminWarrantyListComponent} from './components/admin/admin-warranty-list/admin-warranty-list.component';
import {E4nUploadComponent} from './components/admin/e4n-upload/e4n-upload.component';
import {CookieService} from 'ngx-cookie-service';
import {SupportComponent} from './components/support/support.component';
import {ActionPeriodComponent} from './components/admin/action-periods/action-period/action-period.component';
import {ActionPeriodListComponent} from './components/admin/action-periods/action-period-list/action-period-list.component';
import {ConfigurableDateComponent} from './configurable-date/configurable-date.component';
import {SpecialRequestComponent} from './special-request/special-request.component';
import {SwitchComponent} from './switch/switch.component';
import {ErrorFieldComponent} from './error-field/error-field.component';
import {SpecialRequestItemComponent} from './special-request/special-request-item/special-request-item.component';
import {DeclineComponent} from './special-request/decline/decline.component';
import {PremiumCalculationComponent} from './special-request/premium-calculation/premium-calculation.component';
import {ContractsOverviewComponent} from './components/reports/contracts-overview/contracts-overview.component';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {InvoiceSummaryComponent} from './components/reports/invoice-summary/invoice-summary.component';
import {SearchPipe} from './components/commons/pipe/search.pipe';
import {ReportComponent} from './components/reports/report/report.component';
import {WarrentySummaryComponent} from './components/reports/warrenty-summary/warrenty-summary.component';
import {DealerAgeComponent} from './components/reports/dealer-age/dealer-age.component';
import {EstimationComponent} from './estimation/estimation.component';
import {EstimationDetailsComponent} from './estimation/estimation-details/estimation-details.component';
import {EstimationInputComponent} from './estimation/estimation-input/estimation-input.component';
import {EstimationResultComponent} from './estimation/estimation-result/estimation-result.component';
import {PreviousAgContractComponent} from './special-request/previous-ag-contract/previous-ag-contract.component';
import {ModelGroupComponent} from './model-group/model-group.component';
import {ModelGroupItemComponent} from './model-group/model-group-item/model-group-item.component';
import {AgeMileageComponent} from './components/admin/warranty-config/age-mileage/age-mileage.component';
import {ModelComponent} from './components/admin/warranty-config/model/model.component';
import {PricingMatrixComponent} from './components/admin/warranty-config/pricing-matrix/pricing-matrix.component';
import {CustomDatePipe} from './services/custom-date.pipe';
import {FullExportComponent} from './components/reports/full-export/full-export.component';
import {CancelModalComponent} from './components/warranty/cancel-modal/cancel-modal.component';
import {CreditNoteSummaryComponent} from './components/reports/credit-note-summary/credit-note-summary.component';
import {FilterService} from './components/warranty-list/filter-service';
import {MessagesComponent} from './components/messages/messages.component';
import {MessageMenuComponent} from './components/messages/message-menu/message-menu.component';
import { DealerCorrectionReviewComponent } from './dealer-correction-review/dealer-correction-review.component';
import { FileDragAndDropDirective} from './components/commons/directive/file-drag-n-drop.directive';
import { AdminWarrantyConditionsComponent} from './components/admin/admin-warranty-conditions-upload/admin-warranty-conditions.component';
import { FileTypeVerifierPipe } from './services/filetype-verifier.pipe';
import {UploadWarrantyContractsComponent} from './components/warranty-list/upload-warranty-contracts/upload-warranty-contracts/upload-warranty-contracts.component';
import {FailedUploadExportComponent} from './components/reports/failed-upload-export/failed-upload-export.component';
import { OAuthModule } from 'angular-oauth2-oidc';

@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        LoadingComponent,
        WarrantyListComponent,
        WarrantyComponent,
        I18nPipe,
        SanitizePipe,
        CustomDatePipe,
        CustomerDetailsComponent,
        WarrantySummaryComponent,
        BlacklistComponent,
        DealerListComponent,
        AdminPromotionsComponent,
        HelpConfigComponent,
        DisclaimerConfigComponent,
        WarrantyConfigComponent,
        DealerListComponent,
        AcceptModalComponent,
        CancelModalComponent,
        AdminMenuComponent,
        LoginComponent,
        LogoutComponent,
        PromotionsComponent,
        PromotionComponent,
        HelpComponent,
        EamComponent,
        CalcLogComponent,
        AdminWarrantyListComponent,
        E4nUploadComponent,
        SupportComponent,
        ActionPeriodComponent,
        ActionPeriodListComponent,
        ConfigurableDateComponent,
        SpecialRequestComponent,
        SwitchComponent,
        ErrorFieldComponent,
        SpecialRequestItemComponent,
        DeclineComponent,
        PremiumCalculationComponent,
        ContractsOverviewComponent,
        InvoiceSummaryComponent,
        SearchPipe,
        ReportComponent,
        WarrentySummaryComponent,
        DealerAgeComponent,
        EstimationComponent,
        EstimationDetailsComponent,
        EstimationInputComponent,
        EstimationResultComponent,
        PreviousAgContractComponent,
        ModelGroupComponent,
        ModelGroupItemComponent,
        AgeMileageComponent,
        ModelComponent,
        PricingMatrixComponent,
        FullExportComponent,
        CreditNoteSummaryComponent,
        FailedUploadExportComponent,
        MessagesComponent,
        MessageMenuComponent,
        DealerCorrectionReviewComponent,
        FileDragAndDropDirective,
        AdminWarrantyConditionsComponent,
        FileTypeVerifierPipe,
        UploadWarrantyContractsComponent,
    ],
    exports: [SearchPipe],
    bootstrap: [AppComponent], imports: [AccordionModule.forRoot(),
        BrowserModule,
        AppRoutingModule,
        FormsModule, ReactiveFormsModule,
        NgbModule,
        TabsModule.forRoot(),
        FileUploadModule,
        NgMultiSelectDropDownModule.forRoot(),
        OAuthModule.forRoot()], providers: [AuthGuardService, CookieService,
        I18nProvider, FilterService, SanitizePipe, FileTypeVerifierPipe,
        { provide: APP_INITIALIZER, useFactory: i18nProviderFactory, deps: [I18nProvider], multi: true },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoadingScreenInterceptor,
            multi: true,
        }, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule {
}
